export default "__VITE_ASSET__CEqn43dF__"